<template>
  <v-btn
    color="#013254"
    dark
    height="34"
    class="text-transform-none"
    title="SINCRONIZAR ALTERAÇÕES FEITAS EM TODAS AS TELAS."
    @click="sincronizar"
  >
    <v-icon class="ml-n1 mr-2" size="25" color="#EFEFF0">mdi-sync</v-icon>
    Sincronizar Alterações
  </v-btn>
</template>

<script setup>
import api from "@/api/api";
import {logout} from "@/helpers";

function sincronizar() {
  api.put(`carteiras/v2/sincronizacao`)
    .then(() => {})
    .catch(logout);
}
</script>
